export default function arrayToObject<T extends Record<K, any>, K extends string>(arr: T[], key: K) {
  const accu: Record<any, any> = {};
  return arr.reduce((acc, item) => {
    acc[item[key]] = item;
    return acc;
  }, accu);
}
